import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "small text-muted"
};
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_3 = {
  class: "form-label",
  for: "tenant-access-choose"
};
const _hoisted_4 = {
  class: "form-label",
  for: "tenant-access-reason"
};
const _hoisted_5 = {
  class: "form-label",
  for: "tenant-access-minutes"
};
const _hoisted_6 = ["value"];
const _hoisted_7 = {
  key: 2,
  class: "text-danger small mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lookup_select = _resolveComponent("lookup-select");
  const _component_BModal = _resolveComponent("BModal");
  return _openBlock(), _createBlock(_component_BModal, {
    "model-value": $data.show,
    title: ($options.isChoose ? _ctx.$t('users.tenant_entry.choose_title') : $options.isEnter ? _ctx.$t('users.tenant_entry.enter_title', {
      name: $options.targetName
    }) : _ctx.$t('users.tenant_entry.write_title')).ucFirst(),
    "ok-title": ($options.isEnter ? _ctx.$t('users.tenant_entry.enter_confirm') : _ctx.$t('users.tenant_entry.write_enable')).ucFirst(),
    "cancel-title": _ctx.$t('base.cancel').ucFirst(),
    "ok-disabled": !$options.canConfirm,
    "ok-variant": "warning",
    "no-close-on-backdrop": "",
    "data-test": "tenant-access-prompt",
    onOk: _withModifiers($options.confirm, ["prevent"]),
    onCancel: _cache[3] || (_cache[3] = $event => $options.close(false)),
    onClose: _cache[4] || (_cache[4] = $event => $options.close(false)),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = v => {
      if (!v && $data.resolve) $options.close(false);
    })
  }, {
    default: _withCtx(() => [_createElementVNode("p", _hoisted_1, _toDisplayString($options.isChoose ? _ctx.$t('users.tenant_entry.choose_lead') : $options.isEnter ? _ctx.$t('users.tenant_entry.enter_lead', {
      name: $options.targetName
    }) : _ctx.$t('users.tenant_entry.write_prompt_lead', {
      name: $options.targetName
    })), 1), $options.isChoose ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('users.tenant_entry.label').ucFirst()), 1), _createVNode(_component_lookup_select, {
      id: "tenant-access-choose",
      modelValue: $data.chosenTenantId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.chosenTenantId = $event),
      options: _ctx.tenants,
      "label-field": "name",
      "data-test": "tenant-access-choose"
    }, null, 8, ["modelValue", "options"])])) : _createCommentVNode("", true), $options.needsWrite ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('users.tenant_entry.write_reason').ucFirst()), 1), _withDirectives(_createElementVNode("textarea", {
      id: "tenant-access-reason",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.reason = $event),
      class: "form-control mb-3",
      rows: "3",
      maxlength: "500",
      "data-test": "tenant-access-reason"
    }, null, 512), [[_vModelText, $data.reason]]), _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('users.tenant_entry.write_minutes').ucFirst()), 1), _withDirectives(_createElementVNode("select", {
      id: "tenant-access-minutes",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.minutes = $event),
      class: "form-select",
      "data-test": "tenant-access-minutes"
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.minuteOptions, m => {
      return _openBlock(), _createElementBlock("option", {
        key: m,
        value: m
      }, _toDisplayString(_ctx.$t('users.tenant_entry.minutes', {
        count: m
      })), 9, _hoisted_6);
    }), 128))], 512), [[_vModelSelect, $data.minutes, void 0, {
      number: true
    }]])], 64)) : _createCommentVNode("", true), $data.error ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($data.error), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model-value", "title", "ok-title", "cancel-title", "ok-disabled", "onOk"]);
}